// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Horizontal drop-down menu styles */

.horizontal-menu {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
  }
  
  .horizontal-menu > li {
    position: relative;
    margin-right: 20px;
  }
  
  .horizontal-menu > li > .menu-category {
    cursor: pointer;
  }
  
  .horizontal-menu .submenu {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    text-align: left;
    background-color: #f9f9f9;
    min-width: 160px;
    z-index: 2000;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  }
  
  .horizontal-menu .submenu li {
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    color: #333;
  }
  
  .horizontal-menu .submenu li:hover {
    background-color: #f1f1f1;
  }
  
  .horizontal-menu > li:hover .submenu {
    display: block;
  }
  `, "",{"version":3,"sources":["webpack://./src/css/HorizontalMenu.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;IACI,qBAAqB;IACrB,UAAU;IACV,SAAS;IACT,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,+CAA+C;EACjD;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB","sourcesContent":["/* Horizontal drop-down menu styles */\n\n.horizontal-menu {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n  }\n  \n  .horizontal-menu > li {\n    position: relative;\n    margin-right: 20px;\n  }\n  \n  .horizontal-menu > li > .menu-category {\n    cursor: pointer;\n  }\n  \n  .horizontal-menu .submenu {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    text-align: left;\n    background-color: #f9f9f9;\n    min-width: 160px;\n    z-index: 2000;\n    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  }\n  \n  .horizontal-menu .submenu li {\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n    color: #333;\n  }\n  \n  .horizontal-menu .submenu li:hover {\n    background-color: #f1f1f1;\n  }\n  \n  .horizontal-menu > li:hover .submenu {\n    display: block;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
